/**
 * Csv Schema of AuditoriaObservacao
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {AuditoriaObservacao} from '@/model/resource/AuditoriaObservacao'

/* TODO: review generated schema */
export class CsvAuditoriaObservacaoSchema extends Schema {
  readonly name = 'CsvAuditoriaObservacao'

  readonly fieldSet: FieldSet<AuditoriaObservacao> = {
    idObservacaoPk: schema => schema.model.idObservacaoPk,
    carga: schema => schema.model.carga?.$id ?? null,
    responsavel: schema => schema.model.responsavel?.$id ?? null,
    texto: schema => schema.model.texto,
    dataEnvio: schema => Helper.datetime(schema.model.dataEnvio),
  }
}
